var map = {
	"./air-conditioner.svg": 1333,
	"./airplane.svg": 1334,
	"./airport.svg": 1335,
	"./approved.svg": 1336,
	"./aquapark.svg": 1337,
	"./arrow-answer-bubble.svg": 1338,
	"./arrow-back.svg": 1339,
	"./arrow-flight.svg": 1340,
	"./arrow-right-top.svg": 1341,
	"./arrow-right.svg": 1342,
	"./bar.svg": 1343,
	"./beach-surface-pebble.svg": 1344,
	"./beach-surface-platform.svg": 1345,
	"./beach-surface-sand-pebble.svg": 1346,
	"./beach-surface-sand.svg": 1347,
	"./beachsurface.svg": 1348,
	"./card.svg": 1349,
	"./check.svg": 1350,
	"./clock.svg": 1351,
	"./cvv.svg": 1352,
	"./double-arrow.svg": 1353,
	"./empty-hotel-map.svg": 1354,
	"./filters/clear-filters.svg": 1355,
	"./filters/filter-button.svg": 1356,
	"./filters/instant-confirm-colored.svg": 1357,
	"./filters/instant-confirm.svg": 1358,
	"./filters/search-distance.svg": 1359,
	"./filters/search-lift.svg": 1360,
	"./fire.svg": 1361,
	"./flight-direct-mobile.svg": 1362,
	"./flight-direct.svg": 1363,
	"./flight-direct__additional-mobile.svg": 1364,
	"./flight-direct__additional.svg": 1365,
	"./flight-transition-mobile.svg": 1366,
	"./flight-transition.svg": 1367,
	"./flight-transition__additional-mobile.svg": 1368,
	"./flight-transition__additional.svg": 1369,
	"./food.svg": 1370,
	"./free-cancellation-colored.svg": 1371,
	"./fuel-green.svg": 1372,
	"./fuel-white.svg": 1373,
	"./funicular.svg": 1374,
	"./gallery-empty.svg": 1375,
	"./garranty.svg": 1376,
	"./gender-female.svg": 1377,
	"./gender-male.svg": 1378,
	"./gender-unidentified.svg": 1379,
	"./gift.svg": 1380,
	"./glass.svg": 1381,
	"./gym.svg": 1382,
	"./hand-luggage.svg": 1383,
	"./heated-pool.svg": 1384,
	"./hold-luggage.svg": 1385,
	"./hotel-reply.svg": 1386,
	"./included-services.svg": 1387,
	"./included.svg": 1388,
	"./kids-club.svg": 1389,
	"./kids-menu.svg": 1390,
	"./kids-pool.svg": 1391,
	"./lightning.svg": 1392,
	"./lock.svg": 1393,
	"./logo.svg": 1394,
	"./lt-extra/bonus_insurance.svg": 1395,
	"./lt-extra/bonus_ivi.svg": 1396,
	"./luggage-wrapping.svg": 1397,
	"./man.svg": 1398,
	"./map-button.svg": 1399,
	"./map/collapse-arrows.svg": 1400,
	"./map/expand-arrows.svg": 1401,
	"./massage.svg": 1402,
	"./nanny.svg": 1403,
	"./only-lt-half.svg": 1404,
	"./parking.svg": 1405,
	"./payment-mir.svg": 1406,
	"./paymenttype.svg": 1407,
	"./plane-arrival.svg": 1408,
	"./plane.svg": 1409,
	"./private-beach.svg": 1410,
	"./rest_types/active.svg": 1411,
	"./rest_types/couples.svg": 1412,
	"./rest_types/family.svg": 1413,
	"./review-tab-selected.svg": 1414,
	"./sauna.svg": 1415,
	"./search-sorting.svg": 1416,
	"./searcher-empty-request.svg": 1417,
	"./searcher-filtered-empty.svg": 1418,
	"./sidebar-bottom-triangle.svg": 1419,
	"./sidebar-menu-active.svg": 1420,
	"./sign_additional.svg": 1421,
	"./ski-in-ski-out.svg": 1422,
	"./social-fb.svg": 1423,
	"./social-share.svg": 1424,
	"./social-vk.svg": 1425,
	"./special.svg": 1426,
	"./success_additional.svg": 1427,
	"./swimming-pool.svg": 1428,
	"./thumbs-up.svg": 1429,
	"./wave.svg": 1430,
	"./wifi.svg": 1431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;